<gc-modal
  [headerTitle]="'sharepointExport.helpModal.title' | translate"
  [width]="'fullscreen'"
  [headerIcon]="'circleQuestion'"
  (closeModal)="closeModal()"
>
  <div class="modal-content">
    <section>
      <gc-text [variant]="'minorHeading'">
        {{ 'sharepointExport.helpModal.intro.title' | translate }}
      </gc-text>
      <gc-text [variant]="'paragraph'">
        {{ 'sharepointExport.helpModal.intro.body' | translate }}
      </gc-text>
    </section>
    <section>
      <gc-text [variant]="'minorHeading'">
        {{ 'sharepointExport.helpModal.howItWorks.title' | translate }}
      </gc-text>
      <gc-text [variant]="'paragraph'">
        {{ 'sharepointExport.helpModal.howItWorks.body' | translate }}
      </gc-text>
    </section>
    <section>
      <gc-text [variant]="'minorHeading'">
        {{
          'sharepointExport.helpModal.exportableReportsCompleted.title'
            | translate
        }}
      </gc-text>
      <gc-text [variant]="'paragraph'">
        {{
          'sharepointExport.helpModal.exportableReportsCompleted.body'
            | translate
        }}
      </gc-text>
      <div class="table-wrapper">
        @for (data of exportableReportsCompletedData; track $index) {
          <div class="span-wrapper">
            <gc-text [textColor]="'secondary'">
              {{
                'sharepointExport.helpModal.exportableReportsCompleted.reportType.' +
                  data.reportType | translate
              }}
            </gc-text>
            <gc-text>
              {{
                'sharepointExport.helpModal.exportableReportsCompleted.dod.' +
                  data.dod | translate
              }}
            </gc-text>
          </div>
        }
      </div>
    </section>
    <section>
      <gc-text [variant]="'minorHeading'">
        {{ 'sharepointExport.helpModal.tableDetails.title' | translate }}
      </gc-text>
      <div class="table-wrapper">
        @for (data of tableDetailsData; track $index) {
          <div class="span-wrapper">
            <gc-text [textColor]="'secondary'">
              {{
                'sharepointExport.helpModal.tableDetails.' + data | translate
              }}
            </gc-text>
            <gc-text>
              {{
                'sharepointExport.helpModal.tableDetails.' + data + 'Info'
                  | translate
              }}
            </gc-text>
          </div>
        }
      </div>
    </section>
    <section>
      <gc-text [variant]="'minorHeading'">
        {{ 'sharepointExport.helpModal.statusForExport.title' | translate }}
      </gc-text>
      <div class="table-wrapper">
        @for (data of statusForExportData; track $index) {
          <div class="span-wrapper">
            <gc-text [textColor]="data.color">
              {{
                'sharepointExport.helpModal.statusForExport.' + data.status
                  | translate
              }}
            </gc-text>
            <gc-text>
              {{
                'sharepointExport.helpModal.statusForExport.' +
                  data.status +
                  'Info' | translate
              }}
            </gc-text>
          </div>
        }
      </div>
    </section>
  </div>
</gc-modal>
